<template>
    <q-layout view="lHh lpR fFf" style="background-color: #F3F3F7;">

        <q-drawer v-model="drawer" show-if-above :mini="!drawer || miniState" @click.capture="drawerClick" :width="250"
            :breakpoint="500" content-class="bg-white">
            <q-scroll-area class="fit" :horizontal-thumb-style="{ opacity: 0 }">
                <q-list :class="[{ 'q-pa-md': !miniState }, { 'rounded-borders': !miniState }, 'text-primary']">
                    <div class=" text-center" :class="{ 'mini-logo-container': miniState }">
                        <router-link to="/dashboard/admin/inicio">
                            <img v-if="!miniState" src="../../assets/logo_top.png"
                                :alt="miniState ? 'Logo Mini' : 'Logo Completo'"
                                :style="miniState ? 'width: 48px; height: 48px; cursor:pointer; ' : 'width: 150px; height: auto; cursor:pointer; '"
                                fit="contain" class="logo-image" />
                            <img v-else src="../../assets/logo_top_mini.png"
                                :alt="miniState ? 'Logo Mini' : 'Logo Completo'"
                                :style="miniState ? 'width: 40px; height: 40px;  cursor:pointer;' : 'width: 150px; height: auto;  cursor:pointer;'"
                                fit="contain" class="logo-image" to="/dashboard/admin/inicio" />
                        </router-link>
                    </div>
                    <q-separator color="primary" />

                    <q-item clickable v-ripple :active="link === 'reportes'" @click="link = 'reportes'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/reportes">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-table-box-multiple-outline" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Reportes
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'expediente'" @click="link = 'expediente'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/expedientes">
                        <q-item-section avatar>
                            <q-icon name="laptop_car" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Expedientes
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'proveedores'" @click="link = 'proveedores'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/proveedores">
                        <q-item-section avatar>
                            <q-icon name="mdi-dolly" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Proveedores
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'marca'" @click="link = 'marca'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/marca">
                        <q-item-section avatar>
                            <q-icon name="star" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Marca
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'Modelo'" @click="link = 'Modelo'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/modelo">
                        <q-item-section avatar>
                            <q-icon name="mdi-shape" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Modelo
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'autos'" @click="link = 'autos'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/autos">
                        <q-item-section avatar>
                            <q-icon name="mdi-car" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Autos
                        </q-item-section>
                    </q-item>
                    <q-item clickable v-ripple :active="link === 'clientes'" @click="link = 'clientes'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/clientes">
                        <q-item-section avatar>
                            <q-icon name="mdi-account-group" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Mis Clientes
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'solicitudes'" @click="link = 'solicitudes'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/solicitudes">
                        <q-item-section avatar>
                            <q-icon name="mdi-clipboard-text" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Solicitudes
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'cotizaciones'" @click="link = 'cotizaciones'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/cotizaciones">
                        <q-item-section avatar>
                            <q-icon name="mdi-calculator-variant" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Cotizaciones
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'cuentas'" @click="link = 'cuentas'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/cuentasporcobrar">
                        <q-item-section avatar>
                            <q-icon name="mdi-account-cash" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Cuentas por Cobrar
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'cuentasPagar'" @click="link = 'cuentasPagar'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/cuentasporpagar">
                        <q-item-section avatar>
                            <q-icon name="mdi-cash-minus" class=" class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Cuentas por Pagar
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'contratos'" @click="link = 'contratos'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/contratos">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-document-edit" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Contratos
                        </q-item-section>
                    </q-item>

                    <!-- <q-item clickable v-ripple :active="link === 'contratos-anteriores'"
                        @click="link = 'contratos-anteriores'" active-class="my-menu-link" class="rounded-borders"
                        to="/dashboard/admin/contratos-anteriores">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-document-edit" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Contratos Anteriores
                        </q-item-section>
                    </q-item> -->

                    <q-item clickable v-ripple :active="link === 'Seguros'" @click="link = 'Seguros'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/seguros">
                        <q-item-section avatar>
                            <q-icon name="mdi-security" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Seguros
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'Localizadores'" @click="link = 'Localizadores'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/localizadores">
                        <q-item-section avatar>
                            <q-icon name="mdi-car-connected" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Localizadores
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'facturacion'" @click="link = 'facturacion'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/facturacion">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-document" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Facturación
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'facturacion-rfc'" @click="link = 'facturacion-rfc'"
                        active-class="my-menu-link" class="rounded-borders" to="/dashboard/admin/facturacion-rfc">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-document" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Facturación por RFC
                        </q-item-section>
                    </q-item>

                    <q-item clickable v-ripple :active="link === 'facturacion-pendiente'"
                        @click="link = 'facturacion-pendiente'" active-class="my-menu-link" class="rounded-borders"
                        to="/dashboard/admin/facturacion-pendiente">
                        <q-item-section avatar>
                            <q-icon name="mdi-file-document" class="class-menu-icono" />
                        </q-item-section>
                        <q-item-section>
                            Pendiente de Facturar
                        </q-item-section>
                    </q-item>

                </q-list>
            </q-scroll-area>
        </q-drawer>

        <q-header class="rounded-borders q-ma-md " elevated height-hint="64">
            <q-toolbar class="bg-white shadow-1 rounded-borders  q-py-md">
                <q-btn flat round dense>
                    <q-icon class="text-grey" name="mdi-menu" @click="miniState = !miniState" />
                </q-btn>
                <q-input dense borderless v-model="text" label="Buscar" input-class="text-left" class="q-ml-md">
                    <template v-slot:prepend>
                        <q-icon v-if="text === ''" class="text-grey" name="mdi-magnify" />
                        <q-icon v-else name="clear" class="cursor-pointer" @click="text = ''" />
                    </template>
                </q-input>
                <q-space />
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-moon-waning-crescent" />
                </q-btn>
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-white-balance-sunny" />
                </q-btn>
                <q-btn flat round dense class="q-mr-sm">
                    <q-icon class="text-grey" name="mdi-bell" />
                </q-btn>
                <q-avatar class="cursor-pointer">
                    <img :src="adminStore.fotoPerfilBase64">
                    <q-badge color="green" rounded floating />
                    <q-menu content-class="bg-primary text-white" auto-close>
                        <q-list style="min-width: 120px">
                            <q-item clickable to="/dashboard/admin/configuracion">
                                <q-item-section avatar>
                                    <q-icon name="settings" color="white" />
                                </q-item-section>
                                <q-item-section>
                                    Configuración
                                </q-item-section>
                            </q-item>
                            <q-item clickable @click="logout()">
                                <q-item-section avatar>
                                    <q-icon name="mdi-logout" color="white" />
                                </q-item-section>
                                <q-item-section>
                                    Cerrar Sesión
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                </q-avatar>
            </q-toolbar>
        </q-header>

        <q-page-container>
            <router-view />
        </q-page-container>
    </q-layout>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: "Dashboard",
    data() {
        return {
            leftDrawerOpen: true,
            search: "",
            menu: {
                dashboard: true,
            },

            drawer: false,
            miniState: false,
            text: '',
            link: 'inbox',

            logoSrc: require('../../assets/logo_top.png'),

        };
    },
    computed: {
        adminStore() {
            return this.$store.state.auth.usuario;
        },
    },
    methods: {
        ...mapActions('auth', ['cerrarSesion']),
        logout() {
            this.cerrarSesion()
            this.$router.push({ name: 'login' })
        },

        selectMenu(name) {
            // lógica para cambiar de menú, aquí solo mostramos un ejemplo
            console.log("Seleccionaste:", name);
        },
        toggleDarkMode() {
            this.$q.dark.toggle();
        },
        drawerClick(e) {

            // if (this.miniState) {
            //     this.miniState = false
            //     e.stopPropagation()
            // }
        }
    },
};
</script>

<style>
.q-page-container {
    height: calc(100vh - 0px);
    /* 64px = altura del header, ajusta si tu header es más grande */
    overflow: hidden;
    padding: 0;
}

.q-page {
    height: 100%;
    overflow: hidden;
}

.scrollable-card-container {
    height: 100%;
    overflow-y: auto;
}

.bg-purple {
    background: linear-gradient(45deg, #6a52fa, #a17ff9);
}

.class-menu-icono {
    color: #697A8D;
}

.my-menu-link {
    color: white;
    background: #0094CA;
}

.my-menu-link i {
    color: white;
}

.q-page-container {
    overflow: hidden;
}

/* Ajustes cuando el drawer está en modo mini */
.mini-logo-container {
    padding: 8px !important;
    /* Ajusta el padding para el modo mini */
}

/* Puedes ajustar el color de fondo si lo deseas */
.q-drawer.bg-white {
    background-color: #ffffff;
}
</style>

<!-- <template>
    <div>
        <h1>Panel de Administrador</h1>
        <p>Bienvenido, administrador.</p>
    </div>
</template>

<script>
export default {
    name: 'DashboardAdmin'
}
</script> -->